import React, { useEffect, useState } from "react";
import profileAvatar from "../../../assets/img/profile-avatar-gray.jpg";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import { useAuth } from "../../../contexts/auth";
import TagService from "../../../services/TagService";
import "./ListTags.css";
import { TagTypeText } from "../../../enums/tagTypes";
import { TagTypeIcons } from "../../../utils/tagTypeIcons";

const ListTags = (props) => {
	const [tag, setTag] = useState([]);
	const [maxPage, setMaxPage] = useState(1);
	const { user } = useAuth();
	const [collumnClicked, setCollumnClicked] = useState({
		collumnTitle: "level",
		orderDirection: "ASC",
	});
	const [isLoading, setIsLoading] = useState(true);

	const getTags = async (page, searchText, clientID, collumnClicked) => {
		setIsLoading(true);
		const response =
			await TagService.getPaginatedTags(
				page,
				searchText,
				clientID,
				collumnClicked
			);
		setTag(response.data.items);
		setMaxPage(response.data.pagination.totalPages);
		setIsLoading(false);
	};

	useEffect(() => {
		getTags(1, props.filters, user.userData.selectedOrganizationId, collumnClicked);
	}, [user, props.filters, collumnClicked, props.refreshKey]);

	return (
		<>
			<div className="list-container list-visibility">
				<List
					isLoading={isLoading}
					handleCollumnTitleClick={(collumnIndex) =>
						setCollumnClicked(collumnIndex)
					}
					collumsObjIndex={[
						{
							collumnLabel: "Nome",
							index: "name",
							type: "text",
						},
						{ collumnLabel: "Ícone", index: "icon", type: "icon" },
						{ collumnLabel: "Tipo", index: "type", type: "changeValue" },
						{
							collumnLabel: "Cor", index: "color", type: "custom", custom: ({ row }) => {
								return <span style={{ width: "15px", height: "15px", display: "block", borderRadius: "var(--borderRadius)", backgroundColor: row.color }} />
							}
						},
						{ collumnLabel: "Criado em", index: "organizationName", type: "text" },
					]}
					changeColumnValue={Object.entries(TagTypeText).map(
						([key, text]) => ({
							old: key,
							new: text,
							chip: true,
							// icon: React.createElement(TagTypeIcons[key], { size: 16 })
						}),
					)}
					data={tag}
				/>
			</div>
			<div className="card-visibility">
				{tag &&
					tag.map((tag, index) => (
						<Card
							key={index}
							data={tag}
							image={profileAvatar}
							delete={() => TagService.deleteTag(tag.id)}
							navigateOnDelete={"../consulta-tags"}
							navigateOnEdit={"../cadastro-tags"}
							askForPasswordOnDelete={true}
						>
							<p className="card-content-title">{tag.name_local}</p>
						</Card>
					))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) =>
					getTags(
						page,
						props.filters,
						user.userData.client?.id,
						collumnClicked
					)
				}
			/>
		</>
	);
};

export default ListTags;
